export default __webpack_public_path__ + "static/media/hadena.38c96a0f.svg";